import {
  ActiveFilterState,
  FilterGroup,
  HeaderConfig,
  Row,
} from 'components/Table/KhulaSupplierTable';
import {IWalletTransaction} from 'constants/interfaces';
import {_NumberWithSpaces} from 'constants/index';
import moment from 'moment/moment';
import {Box, Button} from '@material-ui/core';
import React from 'react';

export const walletTableHeaders = (): HeaderConfig[] => [
  {
    field: 'formattedDate',
    title: 'Date',
    isSortable: true,
    isSearchable: true,
    isRightAligned: true,
  },
  {
    field: 'Reference',
    title: 'Reference',
    isSortable: false,
    isSearchable: true,
  },
  {
    field: 'formattedAmount',
    title: 'Amount (R)',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'formattedWithdrawnBy',
    title: 'Withdrawn By',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'formattedWithdrawalDate',
    title: 'Withdrawal Date',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'actions',
    title: '',
    isSortable: false,
    isSearchable: false,
    isCenterAligned: true,
  },
];

export const walletTableRows = (
  transactions: IWalletTransaction[],
  onWithdraw: (transaction: IWalletTransaction) => void,
): Row[] =>
  transactions.map((transaction, index) => ({
    ...transaction,
    id: index,
    formattedDate: moment(transaction.TransactionDate).format('YYYY-MM-DD'),
    formattedAmount: 'R ' + _NumberWithSpaces(transaction.Amount),
    formattedBalance: '',
    formattedWithdrawnBy: formattedWithdrawnBy(transaction),
    formattedWithdrawalDate: formattedWithdrawalDate(transaction),
    isWithdrawable: isWithdrawable(transaction),
    actions: (
      <Actions
        transaction={transaction}
        onWithdraw={() => onWithdraw(transaction)}
      />
    ),
  }));

function isWithdrawable(transaction: IWalletTransaction) {
  const purchaseOrder = transaction.inputsPurchaseOrder;
  const isWithdrawable =
    !!purchaseOrder &&
    !purchaseOrder?.gpayWithdrawDate &&
    !purchaseOrder?.gpayWithdrawUser &&
    !transaction.Reference?.toLowerCase().includes('reversal');
  return isWithdrawable;
}

function formattedWithdrawnBy(transaction: IWalletTransaction) {
  const purchaseOrder = transaction.inputsPurchaseOrder;
  if (!purchaseOrder) return '';
  if (!purchaseOrder.gpayWithdrawDate || !purchaseOrder.gpayWithdrawUser)
    return '';
  const user = purchaseOrder.gpayWithdrawUser;
  return user.name + ' ' + user.surname;
}

function formattedWithdrawalDate(transaction: IWalletTransaction) {
  if (!transaction.inputsPurchaseOrder?.gpayWithdrawDate) return '';
  return moment(
    parseInt(transaction.inputsPurchaseOrder.gpayWithdrawDate),
  ).format('YYYY-MM-DD');
}

function Actions(props: {
  transaction: IWalletTransaction;
  onWithdraw: VoidFunction;
}) {
  const showWithdrawButton = isWithdrawable(props.transaction);
  return (
    <Box display="flex" flexDirection="row" justifyContent="center">
      {showWithdrawButton && (
        <Button
          size="small"
          onClick={props.onWithdraw}
          variant={'contained'}
          disableElevation
          color="primary"
        >
          Withdraw
        </Button>
      )}
    </Box>
  );
}

const TypeFilterGroup: FilterGroup = {
  name: 'Type',
  filters: [
    {
      field: 'isWithdrawable',
      value: true,
      title: 'Withdrawals',
    },
  ],
};

export const walletTableFilters = [TypeFilterGroup];

export const defaultWalletTableActiveFilters: ActiveFilterState[] = [
  {
    filterGroupId: TypeFilterGroup.name,
    filterIndex: 0,
  },
];
